<template>
  <div>
		<pre>{{ shareLink }}</pre>
		<pre v-html="snippetLoaded.content"></pre>
		<button @click="createSnippet()">Compartilhar</button>
	</div>
</template>

<script>
import { db, auth } from '../firebaseInit'

const snippetsRef = db.ref('snippets')

export default {
  name: 'Teste',
	beforeCreate: function() {
		auth.onAuthStateChanged((user) => {
			if (user) {
				this.loggedUser = user
			}
		})
	},
	mounted() {
		if(this.$route.query.uid && this.$route.query.snippetCode){
			var loadSnippet = snippetsRef.child(this.$route.query.uid + '/' + this.$route.query.snippetCode)

			loadSnippet.once('value').then(function(snippetLoaded){
				this.snippetLoaded = snippetLoaded.val()
				console.log(this.snippetLoaded)
			}.bind(this))

		}
	},
  data: () => ({
		loggedUser: null,
		code: '<!DOCTYPE html>\n<html>\n<head>\n\t<link href="https://fonts.googleapis.com/css?family=Lato" rel="stylesheet">\n\t<meta charset="utf-8" />\n\t<meta http-equiv="X-UA-Compatible" content="IE=edge">\n\t<title>Page Title</title>\n\t<meta name="viewport" content="width=device-width, initial-scale=1">\n</head>\n\t<body>\n\t\t<h1>Editor Resultam</h1>\n\t\t<p>Aqui você pode escrever <strong>o seu</strong> html!</p>\n\t\t<a target="blank" href="https://resultam.com">Resultam.com</a>\n\t</body>\n</html>\n<style>\n\thtml {\n\t\tfont-family: "Lato", sans-serif;\n\t}\n</style>',
		lastSnippet: null,
		mySnippetsList: {},
		shareLink: null,
		snippetLoaded: {}
  }),
	firebase() {
		return {
			snippetsList: {
				source: snippetsRef,
				asObject: true
			}
		}
	},
  methods: {
    createSnippet() {
			var userSnippetsRef = snippetsRef.child(this.loggedUser.uid)
			var newSnippet = userSnippetsRef.push()
			newSnippet.set({
				content: this.code.replace(/\n/g,'%0A').replace(/\t/g,'%09').replace(/'/g, 'ç~').replace(/"/g, '~z').replace(/\s/g, '~q')
			}).then( snippet => {
				var link = window.location.protocol + '//' + window.location.host +'/teste/?uid=' + this.loggedUser.uid + '&snippetCode=' + newSnippet.key
				this.shareLink = link
				this.lastSnippet = newSnippet.key
			}, function(err){
				console.log(err)
			}.bind(this))
		}
  },
	watch: {
		loggedUser: {
			handler(loggedUser){
				let mySnippetsRef = snippetsRef.child(this.loggedUser.uid)
				mySnippetsRef.once('value').then(function(mySnippetsList){
					this.mySnippetsList = mySnippetsList.val()
					console.log(mySnippetsList)
				}.bind(this))
			}
		}
	}
}
</script>

<style lang="scss" scoped>
	.loader {
		position: absolute;
		width: 100%;
		height: 100vh;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		transition: all .6s;
		background: #fff;
		opacity: 0;
		z-index: -1;
		text-align: center;
		&.active {
			z-index: 9990;
			opacity: 1;
		}
		.loader-icon {
			margin-top: calc(50vh - 16px); 
		}
	}
</style>
